<template>
  <div>
    <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0"></h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="getDataStatement()"><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
        </div>
    </div>
    <a-table :columns="columns" :dataSource="data" rowKey='depositCode' :scroll="{ x: 1500, y: 300 }">
      <h6 slot="status" slot-scope="status, record">
        <b-badge href="#" @click="useAction(record.bankPaymentId,status)" :loading="isloading" pill :variant="getStatus('bankPayment',status).color">{{getStatus('bankPayment',status).name}}</b-badge>
      </h6>
    </a-table>
    <a-modal v-model="modelShowDetail" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดรายการที่จับคู่กับ # {{(!this.datatransection.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection.bankPaymentId }}</strong>
        </h5>
        <dl class="row">
          <dt class="col-sm-3">รหัสรายการ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.depositCode)?"ไม่พบข้อมูล":this.datatransection.depositCode }}</dd>

          <dt class="col-sm-3">บัญชีลูกค้า :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.userBankTranfer)?"ไม่พบข้อมูล":this.datatransection.userBankTranfer }}</dd>

          <dt class="col-sm-3">บัญชีระบบ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection.systemBankTranfer }}</dd>

          <dt class="col-sm-3 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.amount)?"ไม่พบข้อมูล":this.datatransection.amount }}</dd>

          <dt class="col-sm-3">สถานะ :</dt>
          <dd class="col-sm-9"><b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">{{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge></dd>
        </dl>
      </div>
    </a-modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import moment from 'moment'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectOperator: 'getSelectOperator',
      getSelectBankService: 'getSelectBankService',
      getSelectStatus: 'getSelectStatus',
      getKeyword: 'getKeyword',
    }),
  },
  watch: {
    getStartDate: function(val) {
      this.getDataStatement()
    },
    getSelectOperator: function() {
      this.getDataStatement()
    },
    getSelectBankService: function() {
      this.getDataStatement()
    },
    getSelectStatus: function() {
      this.getDataStatement()
    },
    getKeyword: function() {
      this.getDataStatement()
    },
  },
  data() {
    return {
      data: [],
      modelShowDetail: false,
      isloading: false,
      datatransection: {
        bankPaymentId: null,
        depositCode: null,
        amount: null,
        userBankTranfer: null,
        systemBankTranfer: null,
        status: null,
        color: null,
      },
      columns: [
        {
          title: '',
          key: 'bankPaymentId',
          dataIndex: 'bankPaymentId',
        },
        {
          title: 'รหัสคู่ค้า',
          key: 'operatorCode',
          dataIndex: 'operatorCode',
        },
        {
          title: 'บัญชีระบบ',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          width: 250,
        },
        {
          title: 'เวลาโอน',
          key: 'datetimeTranfer',
          dataIndex: 'datetimeTranfer',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
        {
          title: 'เงินเข้า',
          key: 'amountInCome',
          dataIndex: 'amountInCome',
          customRender: (text, row, index) => {
            if (text !== '-') {
              const amountIncomes = parseFloat(text)
              return amountIncomes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            }
            return text
          },
        },
        {
          title: 'เงินออก',
          key: 'amountOutCome',
          dataIndex: 'amountOutCome',
          customRender: (text, row, index) => {
            if (text !== '-') {
              const amountOutComes = parseFloat(text)
              return amountOutComes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            }
            return text
          },
        },
        {
          title: 'รายละเอียด',
          key: 'detail',
          dataIndex: 'detail',
          scopedSlots: {
            customRender: 'detail',
          },
        },
        {
          title: 'สถานะ',
          key: 'status',
          dataIndex: 'bankPaymentStatus',
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          title: 'ธนาคารที่โอน',
          key: 'detailBankNumber',
          dataIndex: 'detailBankNumber',
          scopedSlots: {
            customRender: 'detailBankNumber',
          },
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
      ],
    }
  },
  props: [
    'pageType',
  ],
  methods: {
    useModal(e) {
      this.modelShowDetail = !this.modelShowDetail
    },
    async getDataStatement() {
      const dataStatement = {
        bankType: this.pageType,
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        operatorCode: this.getSelectOperator,
        bankServiceId: this.getSelectBankService,
        status: this.getSelectStatus,
        keyword: this.getKeyword,
        statusKey: 1,
      }

      await apiClient.post('/statement/getData', dataStatement).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.data = res.responseData.data
        }
      })
    },
    getStatus(type, status) {
      // console.log(type)
      return getName(type, status)[0]
    },
    useAction(bankPaymentId, status) {
      if (status === '000') this.showSucces(bankPaymentId)
      if (status === '003') this.showInfo(bankPaymentId)
      if (status === '004') this.reStatus(bankPaymentId, '001')
    },
    showInfo(bankPaymentId) {
      Swal.fire({
        icon: 'info',
        title: 'ต้องการเปลี่ยนสถานะหรือต้องการแนบหลังฐาน?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'เปลี่ยนสถานะ',
        denyButtonText: 'แนบหลักฐาน',
        denyButtonColor: '#17a2b8',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.reStatus(bankPaymentId, '001')
        } else if (result.isDenied) {
          this.showEdit(bankPaymentId, '000')
        }
      })
    },
    async showSucces(bankPaymentId) {
      const dataTransection = {
        bankPaymentId: bankPaymentId,
        dataType: this.pageType,
      }
      await apiClient.post('/statement/getTransection', dataTransection).then(response => {
        this.datatransection = {
          bankPaymentId: null,
          depositCode: null,
          amount: null,
          userBankTranfer: null,
          systemBankTranfer: null,
          status: null,
          color: null,
        }

        const res = response.data
        if (res.code === '000') {
          this.useModal()
          const getData = res.responseData.data[0]

          const getnameStatus = getName(this.pageType, getData.transectionStatus)

          this.datatransection = {
            bankPaymentId: bankPaymentId,
            depositCode: getData.transectionCode,
            amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
            userBankTranfer: getData.bankServiceUser,
            systemBankTranfer: getData.bankServiceSystem,
            status: getnameStatus[0].name,
            color: getnameStatus[0].color,
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`,
        )
      })
    },
    async showEdit(bankPaymentId, statusCode) {
      const { value: formValues } = await Swal.fire({
        title: 'กรุณากรอกหมายเหตุ และ ลิ้งที่อยู่ของรูปสลิปหลักฐาน',
        html:
          '<textarea id="remark" class="swal2-input" placeholder="หมายเหตุ"></textarea>' +
          '<input id="slip" class="swal2-input" placeholder="สลิปหลักฐาน"></input>',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        preConfirm: (value) => {
          if (value) {
            const remark = document.getElementById('remark').value
            const slip = document.getElementById('slip').value

            if (remark === '' || slip === '') {
              Swal.showValidationMessage(
                'กรุณากรอกข้อมูล',
              )
            }

            return [remark, slip]
          }
          return [
            document.getElementById('remark').value,
            document.getElementById('slip').value,
          ]
        },
        allowOutsideClick: () => !Swal.isLoading(),
      })

      if (formValues) {
        Swal.fire({
          title: 'กรุณาตรวจสอบข้อมูล!',
          text: `หมายเหตุ : ${formValues[0]}`,
          imageUrl: `${formValues[1]}`,
          imageWidth: 250,
          imageHeight: 250,
          imageAlt: 'Custom image',
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          preConfirm: (value) => {
            if (value) {
              // ส่งข้อมูลอัปเดทสถานะ
              const data = {
                bankPaymentId: bankPaymentId,
                statusCode: statusCode,
                remark: formValues[0],
                slip: formValues[1],
              }

              return apiClient.post('/statement/setStatusCode', data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.getDataStatement()
          }
        })
      }
    },
    async reStatus(bankPaymentId, statusCode) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการเปลี่ยนสถานะรายการนี้',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            const data = { bankPaymentId: bankPaymentId, statusCode: statusCode }
            return apiClient.post('/statement/reStatusCode', data).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.getDataStatement()
        }
      })
    },
    editStatement(bankPaymentId, slip, remark, statusCode) {

    },
  },
  async created() {
    await this.getDataStatement()
  },
}
</script>

<style>

</style>
